module.exports = __webpack_public_path__ + "media/images/balance-green-star-de5bf6456aa06a2aab93e2e7f7226f79.png";